var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgKioskRegular = function SvgKioskRegular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 9.836c0-.164.027-.328.11-.492L5.491 5.46c.219-.438.656-.711 1.149-.711h10.691c.492 0 .93.273 1.148.71l2.133 3.884c.082.164.137.328.137.492 0 .574-.492 1.039-1.066 1.039H19v7.219c0 .383-.3.656-.656.656a.632.632 0 0 1-.657-.656v-7.219H13.75v6.781a1.08 1.08 0 0 1-1.094 1.094h-6.59a1.08 1.08 0 0 1-1.093-1.094v-6.781h-.684c-.574 0-1.039-.465-1.039-1.04Zm3.035 1.039V13.5h6.152v-2.625H6.285Zm.356-4.813-1.914 3.5h14.52l-1.915-3.5H6.641Zm5.796 11.375v-2.625H6.285v2.626h6.152Z"
  })));
};

export default SvgKioskRegular;